// Web Push do agente logado — /minhas-notificacoes/push (ver WebPushEndpoints.cs no backend).
import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

export interface WebPushDevice {
  id: string
  device: string | null
  service: string
  createdAt: string
  lastSuccessAt: string | null
  endpoint: string
}

const BASE = `${WOOTDASH_BASE}/minhas-notificacoes/push`

export async function getWebPushPublicKey(token: string): Promise<string | null> {
  try {
    const res = await fetch(`${BASE}/chave`, { headers: wootdashAuthHeaders(token) })
    if (!res.ok) return null
    return (await res.json()).publicKey ?? null
  } catch {
    return null
  }
}

/** Nulo = inscrito; senão o problema. */
export async function saveWebPushSubscription(
  token: string, sub: { endpoint: string; p256dh: string; auth: string; device: string | null },
): Promise<string | null> {
  try {
    const res = await fetch(`${BASE}/inscricoes`, {
      method: 'POST',
      headers: { ...wootdashAuthHeaders(token), 'Content-Type': 'application/json' },
      body: JSON.stringify(sub),
    })
    if (res.ok) return null
    return (await res.json().catch(() => null))?.problem ?? `Erro ${res.status} no servidor.`
  } catch {
    return 'Não foi possível falar com o servidor.'
  }
}

export async function deleteWebPushSubscription(token: string, by: { endpoint?: string; id?: string }): Promise<boolean> {
  const qs = by.id ? `id=${encodeURIComponent(by.id)}` : `endpoint=${encodeURIComponent(by.endpoint ?? '')}`
  try {
    const res = await fetch(`${BASE}/inscricoes?${qs}`, { method: 'DELETE', headers: wootdashAuthHeaders(token) })
    return res.ok || res.status === 404
  } catch {
    return false
  }
}

export async function listWebPushDevices(token: string): Promise<WebPushDevice[]> {
  try {
    const res = await fetch(`${BASE}/inscricoes`, { headers: wootdashAuthHeaders(token) })
    return res.ok ? await res.json() : []
  } catch {
    return []
  }
}

/** Quantos navegadores vão receber o teste (0 = nenhum ligado). */
export async function sendWebPushTest(token: string): Promise<number | null> {
  try {
    const res = await fetch(`${BASE}/teste`, { method: 'POST', headers: wootdashAuthHeaders(token) })
    return res.ok ? (await res.json()).devices ?? 0 : null
  } catch {
    return null
  }
}
